<template>
  <div class="mx-2" style="display: inline-block">
    <div class="input-group">
      <b-dropdown :text="searchGroup.name" slot="prepend" :size="size || 'sm'" variant="primary">
      <b-dropdown-item v-for="menu of searchGroup.menus" :key="menu.key" @click="changeSearchName(searchGroup, menu)">{{menu.name}}</b-dropdown-item>
    </b-dropdown>
    <b-form-input :size="size || 'sm'" v-on:keyup.native.enter.prevent="changeSearchValue(searchGroup, $event)" :value="searchGroup.value"></b-form-input>
    </div>
    
    <!-- bug fix for enter event prevent -->
    <input type="text" style="display:none;">
    </div>
</template>

<script>
/*
  searchGroups: {
    key: '',
    name: '',
    value: '',
    menus: [{
      name: '',
      value: ''
    }]
  }
*/
function changeSearchName (searchGroup, menu) {
  searchGroup.key = menu.key
  searchGroup.name = menu.name
}

function changeSearchValue (searchGroup, event) {
  searchGroup.value = event.target.value
  let query = {}

  // 将同一组的关键字强制置空
  for (let menu of searchGroup.menus) {
    query[menu.key] = ''
  }
  query[searchGroup.key] = searchGroup.value

  this.updateQuery(query)
}

function initSearch () {
  // 根据url里面的参数， 初始化每一个按钮的显示
  this.searchGroup = this.pSearchGroup || {}

  let query = this.$route.query
  for (let key in query) {
    // 查找searchGroup
    for (let menu of this.searchGroup.menus) {
      if (menu.key === key) {
        this.searchGroup.key = key
        this.searchGroup.name = menu.name
        this.searchGroup.value = query[key]
      }
    }
  }
}

function updateQuery (object) {
  let query = Object.assign({}, this.$route.query)

  // remove query
  for (let key in object) {
    let value = object[key]
    if (value === '' || value === 'all') {
      delete query[key]
    } else {
      query[key] = value
    }
  }

  query.page = 1
  this.$router.push({query: query})
}

export default {
  name: 'search',
  data () {
    return {
      searchGroup: {},
    }
  },
  props: ['pSearchGroup', 'size'],
  methods: {
    changeSearchValue,
    changeSearchName,
    initSearch,
    updateQuery
  },
  mounted () {
    this.initSearch()
  }
}
</script>